// H:\APP_REACT\CIFRA\src\routes.js
import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import SplashScreen from "./Pages/SplashScreen";
import { PublicRoutes, RoutesPrivate } from "./Security/ProtectedRoute";
import { PrivateRoutes } from "./Security/PrivateRoutes";

function AppRoutes() {
  return (
    <Routes>
      {/* Ruta para el Splash Screen */}
      <Route path="/splash" element={<SplashScreen />} />
   
      {/* Rutas protegidas */}
      <Route path="/*" element={<PrivateRoutes />} />
      
      {/* Al iniciar la app se redirige a la pantalla de splash */}
      <Route index element={<Navigate to="/splash" replace />} />
    </Routes>
  );
}

function AppContainer() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}

export { AppContainer as Routes };
